export const CLICKHOUSE_FUNCTIONS = [
    { name: "__actionName", description: "" },
    { name: "__bitBoolMaskAnd", description: "" },
    { name: "__bitBoolMaskOr", description: "" },
    { name: "__bitSwapLastTwo", description: "" },
    { name: "__bitWrapperFunc", description: "" },
    { name: "__getScalar", description: "" },
    { name: "__scalarSubqueryResult", description: "" },
    { name: "_CAST", description: "" },
    { name: "abs", description: "" },
    { name: "accurateCast", description: "" },
    { name: "accurateCastOrDefault", description: "" },
    { name: "accurateCastOrNull", description: "" },
    { name: "acos", description: "" },
    { name: "acosh", description: "" },
    { name: "addDate", description: "" },
    { name: "addDays", description: "" },
    { name: "addHours", description: "" },
    { name: "addInterval", description: "" },
    { name: "addMicroseconds", description: "" },
    { name: "addMilliseconds", description: "" },
    { name: "addMinutes", description: "" },
    { name: "addMonths", description: "" },
    { name: "addNanoseconds", description: "" },
    { name: "addQuarters", description: "" },
    { name: "addressToLine", description: "" },
    { name: "addressToLineWithInlines", description: "" },
    { name: "addressToSymbol", description: "" },
    { name: "addSeconds", description: "" },
    { name: "addTupleOfIntervals", description: "" },
    { name: "addWeeks", description: "" },
    { name: "addYears", description: "" },
    { name: "aes_decrypt_mysql", description: "" },
    { name: "aes_encrypt_mysql", description: "" },
    { name: "age", description: "" },
    { name: "aggThrow", description: "" },
    { name: "alphaTokens", description: "" },
    { name: "analysisOfVariance", description: "" },
    { name: "and", description: "" },
    { name: "anova", description: "" },
    { name: "any", description: "" },
    { name: "any_respect_nulls", description: "" },
    { name: "any_value", description: "" },
    { name: "any_value_respect_nulls", description: "" },
    { name: "anyHeavy", description: "" },
    { name: "anyLast", description: "" },
    { name: "anyLast_respect_nulls", description: "" },
    { name: "anyLastRespectNulls", description: "" },
    { name: "anyRespectNulls", description: "" },
    { name: "anyValueRespectNulls", description: "" },
    { name: "appendTrailingCharIfAbsent", description: "" },
    { name: "approx_top_count", description: "" },
    { name: "approx_top_k", description: "" },
    { name: "approx_top_sum", description: "" },
    { name: "argMax", description: "" },
    { name: "argMin", description: "" },
    { name: "array", description: "" },
    { name: "array_agg", description: "" },
    { name: "array_concat_agg", description: "" },
    { name: "arrayAll", description: "" },
    { name: "arrayAUC", description: "" },
    { name: "arrayAUCPR", description: "" },
    { name: "arrayAvg", description: "" },
    { name: "arrayCompact", description: "" },
    { name: "arrayConcat", description: "" },
    { name: "arrayCount", description: "" },
    { name: "arrayCumSum", description: "" },
    { name: "arrayCumSumNonNegative", description: "" },
    { name: "arrayDifference", description: "" },
    { name: "arrayDistinct", description: "" },
    { name: "arrayDotProduct", description: "" },
    { name: "arrayElement", description: "" },
    { name: "arrayElementOrNull", description: "" },
    { name: "arrayEnumerate", description: "" },
    { name: "arrayEnumerateDense", description: "" },
    { name: "arrayEnumerateDenseRanked", description: "" },
    { name: "arrayEnumerateUniq", description: "" },
    { name: "arrayEnumerateUniqRanked", description: "" },
    { name: "arrayExists", description: "" },
    { name: "arrayFill", description: "" },
    { name: "arrayFilter", description: "" },
    { name: "arrayFirst", description: "" },
    { name: "arrayFirstIndex", description: "" },
    { name: "arrayFirstOrNull", description: "" },
    { name: "arrayFlatten", description: "" },
    { name: "arrayFold", description: "" },
    { name: "arrayIntersect", description: "" },
    { name: "arrayJaccardIndex", description: "" },
    { name: "arrayJoin", description: "" },
    { name: "arrayLast", description: "" },
    { name: "arrayLastIndex", description: "" },
    { name: "arrayLastOrNull", description: "" },
    { name: "arrayMap", description: "" },
    { name: "arrayMax", description: "" },
    { name: "arrayMin", description: "" },
    { name: "arrayNormalizedGini", description: "" },
    { name: "arrayPartialReverseSort", description: "" },
    { name: "arrayPartialShuffle", description: "" },
    { name: "arrayPartialSort", description: "" },
    { name: "arrayPopBack", description: "" },
    { name: "arrayPopFront", description: "" },
    { name: "arrayPRAUC", description: "" },
    { name: "arrayProduct", description: "" },
    { name: "arrayPushBack", description: "" },
    { name: "arrayPushFront", description: "" },
    { name: "arrayRandomSample", description: "" },
    { name: "arrayReduce", description: "" },
    { name: "arrayReduceInRanges", description: "" },
    { name: "arrayResize", description: "" },
    { name: "arrayReverse", description: "" },
    { name: "arrayReverseFill", description: "" },
    { name: "arrayReverseSort", description: "" },
    { name: "arrayReverseSplit", description: "" },
    { name: "arrayROCAUC", description: "" },
    { name: "arrayRotateLeft", description: "" },
    { name: "arrayRotateRight", description: "" },
    { name: "arrayShiftLeft", description: "" },
    { name: "arrayShiftRight", description: "" },
    { name: "arrayShingles", description: "" },
    { name: "arrayShuffle", description: "" },
    { name: "arraySlice", description: "" },
    { name: "arraySort", description: "" },
    { name: "arraySplit", description: "" },
    { name: "arrayStringConcat", description: "" },
    { name: "arraySum", description: "" },
    { name: "arraySymmetricDifference", description: "" },
    { name: "arrayUnion", description: "" },
    { name: "arrayUniq", description: "" },
    { name: "arrayWithConstant", description: "" },
    { name: "arrayZip", description: "" },
    { name: "arrayZipUnaligned", description: "" },
    { name: "ascii", description: "" },
    { name: "asin", description: "" },
    { name: "asinh", description: "" },
    { name: "assumeNotNull", description: "" },
    { name: "atan", description: "" },
    { name: "atan2", description: "" },
    { name: "atanh", description: "" },
    { name: "avg", description: "" },
    { name: "avgWeighted", description: "" },
    { name: "bar", description: "" },
    { name: "base58Decode", description: "" },
    { name: "base58Encode", description: "" },
    { name: "base64Decode", description: "" },
    { name: "base64Encode", description: "" },
    { name: "base64URLDecode", description: "" },
    { name: "base64URLEncode", description: "" },
    { name: "basename", description: "" },
    { name: "bin", description: "" },
    { name: "BIT_AND", description: "" },
    { name: "BIT_OR", description: "" },
    { name: "BIT_XOR", description: "" },
    { name: "bitAnd", description: "" },
    { name: "bitCount", description: "" },
    { name: "bitHammingDistance", description: "" },
    { name: "bitmapAnd", description: "" },
    { name: "bitmapAndCardinality", description: "" },
    { name: "bitmapAndnot", description: "" },
    { name: "bitmapAndnotCardinality", description: "" },
    { name: "bitmapBuild", description: "" },
    { name: "bitmapCardinality", description: "" },
    { name: "bitmapContains", description: "" },
    { name: "bitmapHasAll", description: "" },
    { name: "bitmapHasAny", description: "" },
    { name: "bitmapMax", description: "" },
    { name: "bitmapMin", description: "" },
    { name: "bitmapOr", description: "" },
    { name: "bitmapOrCardinality", description: "" },
    { name: "bitmapSubsetInRange", description: "" },
    { name: "bitmapSubsetLimit", description: "" },
    { name: "bitmapToArray", description: "" },
    { name: "bitmapTransform", description: "" },
    { name: "bitmapXor", description: "" },
    { name: "bitmapXorCardinality", description: "" },
    { name: "bitmaskToArray", description: "" },
    { name: "bitmaskToList", description: "" },
    { name: "bitNot", description: "" },
    { name: "bitOr", description: "" },
    { name: "bitPositionsToArray", description: "" },
    { name: "bitRotateLeft", description: "" },
    { name: "bitRotateRight", description: "" },
    { name: "bitShiftLeft", description: "" },
    { name: "bitShiftRight", description: "" },
    { name: "bitSlice", description: "" },
    { name: "bitTest", description: "" },
    { name: "bitTestAll", description: "" },
    { name: "bitTestAny", description: "" },
    { name: "bitXor", description: "" },
    { name: "BLAKE3", description: "" },
    { name: "blockNumber", description: "" },
    { name: "blockSerializedSize", description: "" },
    { name: "blockSize", description: "" },
    { name: "boundingRatio", description: "" },
    { name: "buildId", description: "" },
    { name: "byteHammingDistance", description: "" },
    { name: "byteSize", description: "" },
    { name: "byteSlice", description: "" },
    { name: "byteSwap", description: "" },
    { name: "caseWithExpr", description: "" },
    { name: "caseWithExpression", description: "" },
    { name: "caseWithoutExpr", description: "" },
    { name: "caseWithoutExpression", description: "" },
    { name: "CAST", description: "" },
    { name: "catboostEvaluate", description: "" },
    { name: "categoricalInformationValue", description: "" },
    { name: "cbrt", description: "" },
    { name: "ceil", description: "" },
    { name: "ceiling", description: "" },
    { name: "changeDay", description: "" },
    { name: "changeHour", description: "" },
    { name: "changeMinute", description: "" },
    { name: "changeMonth", description: "" },
    { name: "changeSecond", description: "" },
    { name: "changeYear", description: "" },
    { name: "char", description: "" },
    { name: "CHAR_LENGTH", description: "" },
    { name: "CHARACTER_LENGTH", description: "" },
    { name: "cityHash64", description: "" },
    { name: "clamp", description: "" },
    { name: "coalesce", description: "" },
    { name: "compareSubstrings", description: "" },
    { name: "concat", description: "" },
    { name: "concat_ws", description: "" },
    { name: "concatAssumeInjective", description: "" },
    { name: "concatWithSeparator", description: "" },
    { name: "concatWithSeparatorAssumeInjective", description: "" },
    { name: "connection_id", description: "" },
    { name: "connectionId", description: "" },
    { name: "contingency", description: "" },
    { name: "convertCharset", description: "" },
    { name: "corr", description: "" },
    { name: "corrMatrix", description: "" },
    { name: "corrStable", description: "" },
    { name: "cos", description: "" },
    { name: "cosh", description: "" },
    { name: "cosineDistance", description: "" },
    { name: "count", description: "" },
    { name: "countDigits", description: "" },
    { name: "countEqual", description: "" },
    { name: "countMatches", description: "" },
    { name: "countMatchesCaseInsensitive", description: "" },
    { name: "countSubstrings", description: "" },
    { name: "countSubstringsCaseInsensitive", description: "" },
    { name: "countSubstringsCaseInsensitiveUTF8", description: "" },
    { name: "COVAR_POP", description: "" },
    { name: "COVAR_SAMP", description: "" },
    { name: "covarPop", description: "" },
    { name: "covarPopMatrix", description: "" },
    { name: "covarPopStable", description: "" },
    { name: "covarSamp", description: "" },
    { name: "covarSampMatrix", description: "" },
    { name: "covarSampStable", description: "" },
    { name: "cramersV", description: "" },
    { name: "cramersVBiasCorrected", description: "" },
    { name: "CRC32", description: "" },
    { name: "CRC32IEEE", description: "" },
    { name: "CRC64", description: "" },
    { name: "curdate", description: "" },
    { name: "current_database", description: "" },
    { name: "current_date", description: "" },
    { name: "current_query_id", description: "" },
    { name: "current_schemas", description: "" },
    { name: "current_timestamp", description: "" },
    { name: "current_user", description: "" },
    { name: "currentDatabase", description: "" },
    { name: "currentProfiles", description: "" },
    { name: "currentQueryID", description: "" },
    { name: "currentRoles", description: "" },
    { name: "currentSchemas", description: "" },
    { name: "currentUser", description: "" },
    { name: "cutFragment", description: "" },
    { name: "cutIPv6", description: "" },
    { name: "cutQueryString", description: "" },
    { name: "cutQueryStringAndFragment", description: "" },
    { name: "cutToFirstSignificantSubdomain", description: "" },
    { name: "cutToFirstSignificantSubdomainCustom", description: "" },
    { name: "cutToFirstSignificantSubdomainCustomRFC", description: "" },
    { name: "cutToFirstSignificantSubdomainCustomWithWWW", description: "" },
    { name: "cutToFirstSignificantSubdomainCustomWithWWWRFC", description: "" },
    { name: "cutToFirstSignificantSubdomainRFC", description: "" },
    { name: "cutToFirstSignificantSubdomainWithWWW", description: "" },
    { name: "cutToFirstSignificantSubdomainWithWWWRFC", description: "" },
    { name: "cutURLParameter", description: "" },
    { name: "cutWWW", description: "" },
    { name: "damerauLevenshteinDistance", description: "" },
    { name: "DATABASE", description: "" },
    { name: "DATE", description: "" },
    { name: "date_bin", description: "" },
    { name: "DATE_DIFF", description: "" },
    { name: "DATE_FORMAT", description: "" },
    { name: "DATE_TRUNC", description: "" },
    { name: "dateDiff", description: "" },
    { name: "dateName", description: "" },
    { name: "dateTime64ToSnowflake", description: "" },
    { name: "dateTime64ToSnowflakeID", description: "" },
    { name: "dateTimeToSnowflake", description: "" },
    { name: "dateTimeToSnowflakeID", description: "" },
    { name: "dateTrunc", description: "" },
    { name: "DAY", description: "" },
    { name: "DAYOFMONTH", description: "" },
    { name: "DAYOFWEEK", description: "" },
    { name: "DAYOFYEAR", description: "" },
    { name: "decodeHTMLComponent", description: "" },
    { name: "decodeURLComponent", description: "" },
    { name: "decodeURLFormComponent", description: "" },
    { name: "decodeXMLComponent", description: "" },
    { name: "decrypt", description: "" },
    { name: "defaultProfiles", description: "" },
    { name: "defaultRoles", description: "" },
    { name: "defaultValueOfArgumentType", description: "" },
    { name: "defaultValueOfTypeName", description: "" },
    { name: "degrees", description: "" },
    { name: "deltaSum", description: "" },
    { name: "deltaSumTimestamp", description: "" },
    { name: "demangle", description: "" },
    { name: "dense_rank", description: "" },
    { name: "denseRank", description: "" },
    { name: "detectCharset", description: "" },
    { name: "detectLanguage", description: "" },
    { name: "detectLanguageMixed", description: "" },
    { name: "detectLanguageUnknown", description: "" },
    { name: "detectProgrammingLanguage", description: "" },
    { name: "detectTonality", description: "" },
    { name: "dictGet", description: "" },
    { name: "dictGetAll", description: "" },
    { name: "dictGetChildren", description: "" },
    { name: "dictGetDate", description: "" },
    { name: "dictGetDateOrDefault", description: "" },
    { name: "dictGetDateTime", description: "" },
    { name: "dictGetDateTimeOrDefault", description: "" },
    { name: "dictGetDescendants", description: "" },
    { name: "dictGetFloat32", description: "" },
    { name: "dictGetFloat32OrDefault", description: "" },
    { name: "dictGetFloat64", description: "" },
    { name: "dictGetFloat64OrDefault", description: "" },
    { name: "dictGetHierarchy", description: "" },
    { name: "dictGetInt16", description: "" },
    { name: "dictGetInt16OrDefault", description: "" },
    { name: "dictGetInt32", description: "" },
    { name: "dictGetInt32OrDefault", description: "" },
    { name: "dictGetInt64", description: "" },
    { name: "dictGetInt64OrDefault", description: "" },
    { name: "dictGetInt8", description: "" },
    { name: "dictGetInt8OrDefault", description: "" },
    { name: "dictGetIPv4", description: "" },
    { name: "dictGetIPv4OrDefault", description: "" },
    { name: "dictGetIPv6", description: "" },
    { name: "dictGetIPv6OrDefault", description: "" },
    { name: "dictGetOrDefault", description: "" },
    { name: "dictGetOrNull", description: "" },
    { name: "dictGetString", description: "" },
    { name: "dictGetStringOrDefault", description: "" },
    { name: "dictGetUInt16", description: "" },
    { name: "dictGetUInt16OrDefault", description: "" },
    { name: "dictGetUInt32", description: "" },
    { name: "dictGetUInt32OrDefault", description: "" },
    { name: "dictGetUInt64", description: "" },
    { name: "dictGetUInt64OrDefault", description: "" },
    { name: "dictGetUInt8", description: "" },
    { name: "dictGetUInt8OrDefault", description: "" },
    { name: "dictGetUUID", description: "" },
    { name: "dictGetUUIDOrDefault", description: "" },
    { name: "dictHas", description: "" },
    { name: "dictIsIn", description: "" },
    { name: "displayName", description: "" },
    { name: "distanceL1", description: "" },
    { name: "distanceL2", description: "" },
    { name: "distanceL2Squared", description: "" },
    { name: "distanceLinf", description: "" },
    { name: "distanceLp", description: "" },
    { name: "distinctDynamicTypes", description: "" },
    { name: "distinctJSONPaths", description: "" },
    { name: "distinctJSONPathsAndTypes", description: "" },
    { name: "divide", description: "" },
    { name: "divideDecimal", description: "" },
    { name: "domain", description: "" },
    { name: "domainRFC", description: "" },
    { name: "domainWithoutWWW", description: "" },
    { name: "domainWithoutWWWRFC", description: "" },
    { name: "dotProduct", description: "" },
    { name: "dumpColumnStructure", description: "" },
    { name: "dynamicElement", description: "" },
    { name: "dynamicType", description: "" },
    { name: "e", description: "" },
    { name: "editDistance", description: "" },
    { name: "editDistanceUTF8", description: "" },
    { name: "empty", description: "" },
    { name: "emptyArrayDate", description: "" },
    { name: "emptyArrayDateTime", description: "" },
    { name: "emptyArrayFloat32", description: "" },
    { name: "emptyArrayFloat64", description: "" },
    { name: "emptyArrayInt16", description: "" },
    { name: "emptyArrayInt32", description: "" },
    { name: "emptyArrayInt64", description: "" },
    { name: "emptyArrayInt8", description: "" },
    { name: "emptyArrayString", description: "" },
    { name: "emptyArrayToSingle", description: "" },
    { name: "emptyArrayUInt16", description: "" },
    { name: "emptyArrayUInt32", description: "" },
    { name: "emptyArrayUInt64", description: "" },
    { name: "emptyArrayUInt8", description: "" },
    { name: "enabledProfiles", description: "" },
    { name: "enabledRoles", description: "" },
    { name: "encodeURLComponent", description: "" },
    { name: "encodeURLFormComponent", description: "" },
    { name: "encodeXMLComponent", description: "" },
    { name: "encrypt", description: "" },
    { name: "endsWith", description: "" },
    { name: "endsWithUTF8", description: "" },
    { name: "entropy", description: "" },
    { name: "equals", description: "" },
    { name: "erf", description: "" },
    { name: "erfc", description: "" },
    { name: "errorCodeToName", description: "" },
    { name: "estimateCompressionRatio", description: "" },
    { name: "evalMLMethod", description: "" },
    { name: "exp", description: "" },
    { name: "exp10", description: "" },
    { name: "exp2", description: "" },
    { name: "exponentialMovingAverage", description: "" },
    { name: "exponentialTimeDecayedAvg", description: "" },
    { name: "exponentialTimeDecayedCount", description: "" },
    { name: "exponentialTimeDecayedMax", description: "" },
    { name: "exponentialTimeDecayedSum", description: "" },
    { name: "extract", description: "" },
    { name: "extractAll", description: "" },
    { name: "extractAllGroups", description: "" },
    { name: "extractAllGroupsHorizontal", description: "" },
    { name: "extractAllGroupsVertical", description: "" },
    { name: "extractGroups", description: "" },
    { name: "extractKeyValuePairs", description: "" },
    { name: "extractKeyValuePairsWithEscaping", description: "" },
    { name: "extractTextFromHTML", description: "" },
    { name: "extractURLParameter", description: "" },
    { name: "extractURLParameterNames", description: "" },
    { name: "extractURLParameters", description: "" },
    { name: "factorial", description: "" },
    { name: "farmFingerprint64", description: "" },
    { name: "farmHash64", description: "" },
    { name: "file", description: "" },
    { name: "filesystemAvailable", description: "" },
    { name: "filesystemCapacity", description: "" },
    { name: "filesystemUnreserved", description: "" },
    { name: "finalizeAggregation", description: "" },
    { name: "first_value", description: "" },
    { name: "first_value_respect_nulls", description: "" },
    { name: "firstLine", description: "" },
    { name: "firstNonDefault", description: "" },
    { name: "firstSignificantSubdomain", description: "" },
    { name: "firstSignificantSubdomainCustom", description: "" },
    { name: "firstSignificantSubdomainCustomRFC", description: "" },
    { name: "firstSignificantSubdomainRFC", description: "" },
    { name: "firstValueRespectNulls", description: "" },
    { name: "flameGraph", description: "" },
    { name: "flatten", description: "" },
    { name: "flattenTuple", description: "" },
    { name: "floor", description: "" },
    { name: "format", description: "" },
    { name: "FORMAT_BYTES", description: "" },
    { name: "formatDateTime", description: "" },
    { name: "formatDateTimeInJodaSyntax", description: "" },
    { name: "formatQuery", description: "" },
    { name: "formatQueryOrNull", description: "" },
    { name: "formatQuerySingleLine", description: "" },
    { name: "formatQuerySingleLineOrNull", description: "" },
    { name: "formatReadableDecimalSize", description: "" },
    { name: "formatReadableQuantity", description: "" },
    { name: "formatReadableSize", description: "" },
    { name: "formatReadableTimeDelta", description: "" },
    { name: "formatRow", description: "" },
    { name: "formatRowNoNewline", description: "" },
    { name: "FQDN", description: "" },
    { name: "fragment", description: "" },
    { name: "FROM_BASE64", description: "" },
    { name: "FROM_DAYS", description: "" },
    { name: "FROM_UNIXTIME", description: "" },
    { name: "from_utc_timestamp", description: "" },
    { name: "fromDaysSinceYearZero", description: "" },
    { name: "fromDaysSinceYearZero32", description: "" },
    { name: "fromModifiedJulianDay", description: "" },
    { name: "fromModifiedJulianDayOrNull", description: "" },
    { name: "fromUnixTimestamp", description: "" },
    { name: "fromUnixTimestamp64Micro", description: "" },
    { name: "fromUnixTimestamp64Milli", description: "" },
    { name: "fromUnixTimestamp64Nano", description: "" },
    { name: "fromUnixTimestamp64Second", description: "" },
    { name: "fromUnixTimestampInJodaSyntax", description: "" },
    { name: "fromUTCTimestamp", description: "" },
    { name: "fullHostName", description: "" },
    { name: "fuzzBits", description: "" },
    { name: "gccMurmurHash", description: "" },
    { name: "gcd", description: "" },
    { name: "generateRandomStructure", description: "" },
    { name: "generateSerialID", description: "" },
    { name: "generateSnowflakeID", description: "" },
    { name: "generateULID", description: "" },
    { name: "generateUUIDv4", description: "" },
    { name: "generateUUIDv7", description: "" },
    { name: "geoDistance", description: "" },
    { name: "geohashDecode", description: "" },
    { name: "geohashEncode", description: "" },
    { name: "geohashesInBox", description: "" },
    { name: "geoToH3", description: "" },
    { name: "geoToS2", description: "" },
    { name: "getClientHTTPHeader", description: "" },
    { name: "getMacro", description: "" },
    { name: "getMaxTableNameLengthForDatabase", description: "" },
    { name: "getOSKernelVersion", description: "" },
    { name: "getServerPort", description: "" },
    { name: "getSetting", description: "" },
    { name: "getSettingOrDefault", description: "" },
    { name: "getSizeOfEnumType", description: "" },
    { name: "getSubcolumn", description: "" },
    { name: "getTypeSerializationStreams", description: "" },
    { name: "globalIn", description: "" },
    { name: "globalInIgnoreSet", description: "" },
    { name: "globalNotIn", description: "" },
    { name: "globalNotInIgnoreSet", description: "" },
    { name: "globalNotNullIn", description: "" },
    { name: "globalNotNullInIgnoreSet", description: "" },
    { name: "globalNullIn", description: "" },
    { name: "globalNullInIgnoreSet", description: "" },
    { name: "globalVariable", description: "" },
    { name: "greatCircleAngle", description: "" },
    { name: "greatCircleDistance", description: "" },
    { name: "greater", description: "" },
    { name: "greaterOrEquals", description: "" },
    { name: "greatest", description: "" },
    { name: "group_concat", description: "" },
    { name: "groupArray", description: "" },
    { name: "groupArrayInsertAt", description: "" },
    { name: "groupArrayIntersect", description: "" },
    { name: "groupArrayLast", description: "" },
    { name: "groupArrayMovingAvg", description: "" },
    { name: "groupArrayMovingSum", description: "" },
    { name: "groupArraySample", description: "" },
    { name: "groupArraySorted", description: "" },
    { name: "groupBitAnd", description: "" },
    { name: "groupBitmap", description: "" },
    { name: "groupBitmapAnd", description: "" },
    { name: "groupBitmapOr", description: "" },
    { name: "groupBitmapXor", description: "" },
    { name: "groupBitOr", description: "" },
    { name: "groupBitXor", description: "" },
    { name: "groupConcat", description: "" },
    { name: "groupUniqArray", description: "" },
    { name: "h3CellAreaM2", description: "" },
    { name: "h3CellAreaRads2", description: "" },
    { name: "h3Distance", description: "" },
    { name: "h3EdgeAngle", description: "" },
    { name: "h3EdgeLengthKm", description: "" },
    { name: "h3EdgeLengthM", description: "" },
    { name: "h3ExactEdgeLengthKm", description: "" },
    { name: "h3ExactEdgeLengthM", description: "" },
    { name: "h3ExactEdgeLengthRads", description: "" },
    { name: "h3GetBaseCell", description: "" },
    { name: "h3GetDestinationIndexFromUnidirectionalEdge", description: "" },
    { name: "h3GetFaces", description: "" },
    { name: "h3GetIndexesFromUnidirectionalEdge", description: "" },
    { name: "h3GetOriginIndexFromUnidirectionalEdge", description: "" },
    { name: "h3GetPentagonIndexes", description: "" },
    { name: "h3GetRes0Indexes", description: "" },
    { name: "h3GetResolution", description: "" },
    { name: "h3GetUnidirectionalEdge", description: "" },
    { name: "h3GetUnidirectionalEdgeBoundary", description: "" },
    { name: "h3GetUnidirectionalEdgesFromHexagon", description: "" },
    { name: "h3HexAreaKm2", description: "" },
    { name: "h3HexAreaM2", description: "" },
    { name: "h3HexRing", description: "" },
    { name: "h3IndexesAreNeighbors", description: "" },
    { name: "h3IsPentagon", description: "" },
    { name: "h3IsResClassIII", description: "" },
    { name: "h3IsValid", description: "" },
    { name: "h3kRing", description: "" },
    { name: "h3Line", description: "" },
    { name: "h3NumHexagons", description: "" },
    { name: "h3PointDistKm", description: "" },
    { name: "h3PointDistM", description: "" },
    { name: "h3PointDistRads", description: "" },
    { name: "h3ToCenterChild", description: "" },
    { name: "h3ToChildren", description: "" },
    { name: "h3ToGeo", description: "" },
    { name: "h3ToGeoBoundary", description: "" },
    { name: "h3ToParent", description: "" },
    { name: "h3ToString", description: "" },
    { name: "h3UnidirectionalEdgeIsValid", description: "" },
    { name: "halfMD5", description: "" },
    { name: "has", description: "" },
    { name: "hasAll", description: "" },
    { name: "hasAny", description: "" },
    { name: "hasColumnInTable", description: "" },
    { name: "hasSubsequence", description: "" },
    { name: "hasSubsequenceCaseInsensitive", description: "" },
    { name: "hasSubsequenceCaseInsensitiveUTF8", description: "" },
    { name: "hasSubsequenceUTF8", description: "" },
    { name: "hasSubstr", description: "" },
    { name: "hasThreadFuzzer", description: "" },
    { name: "hasToken", description: "" },
    { name: "hasTokenCaseInsensitive", description: "" },
    { name: "hasTokenCaseInsensitiveOrNull", description: "" },
    { name: "hasTokenOrNull", description: "" },
    { name: "hex", description: "" },
    { name: "hilbertDecode", description: "" },
    { name: "hilbertEncode", description: "" },
    { name: "histogram", description: "" },
    { name: "hiveHash", description: "" },
    { name: "hop", description: "" },
    { name: "hopEnd", description: "" },
    { name: "hopStart", description: "" },
    { name: "hostName", description: "" },
    { name: "HOUR", description: "" },
    { name: "hypot", description: "" },
    { name: "icebergTruncate", description: "" },
    { name: "identity", description: "" },
    { name: "idnaDecode", description: "" },
    { name: "idnaEncode", description: "" },
    { name: "if", description: "" },
    { name: "ifNotFinite", description: "" },
    { name: "ifNull", description: "" },
    { name: "ignore", description: "" },
    { name: "ilike", description: "" },
    { name: "in", description: "" },
    { name: "indexHint", description: "" },
    { name: "indexOf", description: "" },
    { name: "indexOfAssumeSorted", description: "" },
    { name: "INET6_ATON", description: "" },
    { name: "INET6_NTOA", description: "" },
    { name: "INET_ATON", description: "" },
    { name: "INET_NTOA", description: "" },
    { name: "inIgnoreSet", description: "" },
    { name: "initcap", description: "" },
    { name: "initcapUTF8", description: "" },
    { name: "initial_query_id", description: "" },
    { name: "initial_query_start_time", description: "" },
    { name: "initializeAggregation", description: "" },
    { name: "initialQueryID", description: "" },
    { name: "initialQueryStartTime", description: "" },
    { name: "instr", description: "" },
    { name: "intDiv", description: "" },
    { name: "intDivOrZero", description: "" },
    { name: "intervalLengthSum", description: "" },
    { name: "intExp10", description: "" },
    { name: "intExp2", description: "" },
    { name: "intHash32", description: "" },
    { name: "intHash64", description: "" },
    { name: "IPv4CIDRToRange", description: "" },
    { name: "IPv4NumToString", description: "" },
    { name: "IPv4NumToStringClassC", description: "" },
    { name: "IPv4StringToNum", description: "" },
    { name: "IPv4StringToNumOrDefault", description: "" },
    { name: "IPv4StringToNumOrNull", description: "" },
    { name: "IPv4ToIPv6", description: "" },
    { name: "IPv6CIDRToRange", description: "" },
    { name: "IPv6NumToString", description: "" },
    { name: "IPv6StringToNum", description: "" },
    { name: "IPv6StringToNumOrDefault", description: "" },
    { name: "IPv6StringToNumOrNull", description: "" },
    { name: "isConstant", description: "" },
    { name: "isDecimalOverflow", description: "" },
    { name: "isDynamicElementInSharedData", description: "" },
    { name: "isFinite", description: "" },
    { name: "isInfinite", description: "" },
    { name: "isIPAddressInRange", description: "" },
    { name: "isIPv4String", description: "" },
    { name: "isIPv6String", description: "" },
    { name: "isNaN", description: "" },
    { name: "isNotDistinctFrom", description: "" },
    { name: "isNotNull", description: "" },
    { name: "isNull", description: "" },
    { name: "isNullable", description: "" },
    { name: "isValidJSON", description: "" },
    { name: "isValidUTF8", description: "" },
    { name: "isZeroOrNull", description: "" },
    { name: "jaroSimilarity", description: "" },
    { name: "jaroWinklerSimilarity", description: "" },
    { name: "javaHash", description: "" },
    { name: "javaHashUTF16LE", description: "" },
    { name: "joinGet", description: "" },
    { name: "joinGetOrNull", description: "" },
    { name: "JSON_ARRAY_LENGTH", description: "" },
    { name: "JSON_EXISTS", description: "" },
    { name: "JSON_QUERY", description: "" },
    { name: "JSON_VALUE", description: "" },
    { name: "JSONAllPaths", description: "" },
    { name: "JSONAllPathsWithTypes", description: "" },
    { name: "JSONArrayLength", description: "" },
    { name: "JSONDynamicPaths", description: "" },
    { name: "JSONDynamicPathsWithTypes", description: "" },
    { name: "JSONExtract", description: "" },
    { name: "JSONExtractArrayRaw", description: "" },
    { name: "JSONExtractBool", description: "" },
    { name: "JSONExtractFloat", description: "" },
    { name: "JSONExtractInt", description: "" },
    { name: "JSONExtractKeys", description: "" },
    { name: "JSONExtractKeysAndValues", description: "" },
    { name: "JSONExtractKeysAndValuesRaw", description: "" },
    { name: "JSONExtractRaw", description: "" },
    { name: "JSONExtractString", description: "" },
    { name: "JSONExtractUInt", description: "" },
    { name: "JSONHas", description: "" },
    { name: "JSONKey", description: "" },
    { name: "JSONLength", description: "" },
    { name: "JSONMergePatch", description: "" },
    { name: "JSONSharedDataPaths", description: "" },
    { name: "JSONSharedDataPathsWithTypes", description: "" },
    { name: "JSONType", description: "" },
    { name: "jumpConsistentHash", description: "" },
    { name: "kafkaMurmurHash", description: "" },
    { name: "keccak256", description: "" },
    { name: "kolmogorovSmirnovTest", description: "" },
    { name: "kostikConsistentHash", description: "" },
    { name: "kql_array_sort_asc", description: "" },
    { name: "kql_array_sort_desc", description: "" },
    { name: "kurtPop", description: "" },
    { name: "kurtSamp", description: "" },
    { name: "L1Distance", description: "" },
    { name: "L1Norm", description: "" },
    { name: "L1Normalize", description: "" },
    { name: "L2Distance", description: "" },
    { name: "L2Norm", description: "" },
    { name: "L2Normalize", description: "" },
    { name: "L2SquaredDistance", description: "" },
    { name: "L2SquaredNorm", description: "" },
    { name: "lagInFrame", description: "" },
    { name: "largestTriangleThreeBuckets", description: "" },
    { name: "LAST_DAY", description: "" },
    { name: "last_value", description: "" },
    { name: "last_value_respect_nulls", description: "" },
    { name: "lastValueRespectNulls", description: "" },
    { name: "lcase", description: "" },
    { name: "lcm", description: "" },
    { name: "leadInFrame", description: "" },
    { name: "least", description: "" },
    { name: "left", description: "" },
    { name: "leftPad", description: "" },
    { name: "leftPadUTF8", description: "" },
    { name: "leftUTF8", description: "" },
    { name: "lemmatize", description: "" },
    { name: "length", description: "" },
    { name: "lengthUTF8", description: "" },
    { name: "less", description: "" },
    { name: "lessOrEquals", description: "" },
    { name: "levenshteinDistance", description: "" },
    { name: "levenshteinDistanceUTF8", description: "" },
    { name: "lgamma", description: "" },
    { name: "like", description: "" },
    { name: "LinfDistance", description: "" },
    { name: "LinfNorm", description: "" },
    { name: "LinfNormalize", description: "" },
    { name: "ln", description: "" },
    { name: "locate", description: "" },
    { name: "log", description: "" },
    { name: "log10", description: "" },
    { name: "log1p", description: "" },
    { name: "log2", description: "" },
    { name: "logTrace", description: "" },
    { name: "lowCardinalityIndices", description: "" },
    { name: "lowCardinalityKeys", description: "" },
    { name: "lower", description: "" },
    { name: "lowerUTF8", description: "" },
    { name: "lpad", description: "" },
    { name: "LpDistance", description: "" },
    { name: "LpNorm", description: "" },
    { name: "LpNormalize", description: "" },
    { name: "ltrim", description: "" },
    { name: "lttb", description: "" },
    { name: "MACNumToString", description: "" },
    { name: "MACStringToNum", description: "" },
    { name: "MACStringToOUI", description: "" },
    { name: "makeDate", description: "" },
    { name: "makeDate32", description: "" },
    { name: "makeDateTime", description: "" },
    { name: "makeDateTime64", description: "" },
    { name: "mannWhitneyUTest", description: "" },
    { name: "map", description: "" },
    { name: "MAP_FROM_ARRAYS", description: "" },
    { name: "mapAdd", description: "" },
    { name: "mapAll", description: "" },
    { name: "mapApply", description: "" },
    { name: "mapConcat", description: "" },
    { name: "mapContains", description: "" },
    { name: "mapContainsKeyLike", description: "" },
    { name: "mapExists", description: "" },
    { name: "mapExtractKeyLike", description: "" },
    { name: "mapFilter", description: "" },
    { name: "mapFromArrays", description: "" },
    { name: "mapFromString", description: "" },
    { name: "mapKeys", description: "" },
    { name: "mapPartialReverseSort", description: "" },
    { name: "mapPartialSort", description: "" },
    { name: "mapPopulateSeries", description: "" },
    { name: "mapReverseSort", description: "" },
    { name: "mapSort", description: "" },
    { name: "mapSubtract", description: "" },
    { name: "mapUpdate", description: "" },
    { name: "mapValues", description: "" },
    { name: "match", description: "" },
    { name: "materialize", description: "" },
    { name: "max", description: "" },
    { name: "max2", description: "" },
    { name: "maxIntersections", description: "" },
    { name: "maxIntersectionsPosition", description: "" },
    { name: "maxMappedArrays", description: "" },
    { name: "MD4", description: "" },
    { name: "MD5", description: "" },
    { name: "meanZTest", description: "" },
    { name: "median", description: "" },
    { name: "medianBFloat16", description: "" },
    { name: "medianBFloat16Weighted", description: "" },
    { name: "medianDD", description: "" },
    { name: "medianDeterministic", description: "" },
    { name: "medianExact", description: "" },
    { name: "medianExactHigh", description: "" },
    { name: "medianExactLow", description: "" },
    { name: "medianExactWeighted", description: "" },
    { name: "medianExactWeightedInterpolated", description: "" },
    { name: "medianGK", description: "" },
    { name: "medianInterpolatedWeighted", description: "" },
    { name: "medianTDigest", description: "" },
    { name: "medianTDigestWeighted", description: "" },
    { name: "medianTiming", description: "" },
    { name: "medianTimingWeighted", description: "" },
    { name: "metroHash64", description: "" },
    { name: "mid", description: "" },
    { name: "MILLISECOND", description: "" },
    { name: "min", description: "" },
    { name: "min2", description: "" },
    { name: "minMappedArrays", description: "" },
    { name: "minSampleSizeContinous", description: "" },
    { name: "minSampleSizeContinuous", description: "" },
    { name: "minSampleSizeConversion", description: "" },
    { name: "minus", description: "" },
    { name: "MINUTE", description: "" },
    { name: "mismatches", description: "" },
    { name: "mod", description: "" },
    { name: "modulo", description: "" },
    { name: "moduloLegacy", description: "" },
    { name: "moduloOrZero", description: "" },
    { name: "MONTH", description: "" },
    { name: "monthName", description: "" },
    { name: "mortonDecode", description: "" },
    { name: "mortonEncode", description: "" },
    { name: "multiFuzzyMatchAllIndices", description: "" },
    { name: "multiFuzzyMatchAny", description: "" },
    { name: "multiFuzzyMatchAnyIndex", description: "" },
    { name: "multiIf", description: "" },
    { name: "multiMatchAllIndices", description: "" },
    { name: "multiMatchAny", description: "" },
    { name: "multiMatchAnyIndex", description: "" },
    { name: "multiply", description: "" },
    { name: "multiplyDecimal", description: "" },
    { name: "multiSearchAllPositions", description: "" },
    { name: "multiSearchAllPositionsCaseInsensitive", description: "" },
    { name: "multiSearchAllPositionsCaseInsensitiveUTF8", description: "" },
    { name: "multiSearchAllPositionsUTF8", description: "" },
    { name: "multiSearchAny", description: "" },
    { name: "multiSearchAnyCaseInsensitive", description: "" },
    { name: "multiSearchAnyCaseInsensitiveUTF8", description: "" },
    { name: "multiSearchAnyUTF8", description: "" },
    { name: "multiSearchFirstIndex", description: "" },
    { name: "multiSearchFirstIndexCaseInsensitive", description: "" },
    { name: "multiSearchFirstIndexCaseInsensitiveUTF8", description: "" },
    { name: "multiSearchFirstIndexUTF8", description: "" },
    { name: "multiSearchFirstPosition", description: "" },
    { name: "multiSearchFirstPositionCaseInsensitive", description: "" },
    { name: "multiSearchFirstPositionCaseInsensitiveUTF8", description: "" },
    { name: "multiSearchFirstPositionUTF8", description: "" },
    { name: "murmurHash2_32", description: "" },
    { name: "murmurHash2_64", description: "" },
    { name: "murmurHash3_128", description: "" },
    { name: "murmurHash3_32", description: "" },
    { name: "murmurHash3_64", description: "" },
    { name: "negate", description: "" },
    { name: "neighbor", description: "" },
    { name: "nested", description: "" },
    { name: "netloc", description: "" },
    { name: "ngramDistance", description: "" },
    { name: "ngramDistanceCaseInsensitive", description: "" },
    { name: "ngramDistanceCaseInsensitiveUTF8", description: "" },
    { name: "ngramDistanceUTF8", description: "" },
    { name: "ngramMinHash", description: "" },
    { name: "ngramMinHashArg", description: "" },
    { name: "ngramMinHashArgCaseInsensitive", description: "" },
    { name: "ngramMinHashArgCaseInsensitiveUTF8", description: "" },
    { name: "ngramMinHashArgUTF8", description: "" },
    { name: "ngramMinHashCaseInsensitive", description: "" },
    { name: "ngramMinHashCaseInsensitiveUTF8", description: "" },
    { name: "ngramMinHashUTF8", description: "" },
    { name: "ngrams", description: "" },
    { name: "ngramSearch", description: "" },
    { name: "ngramSearchCaseInsensitive", description: "" },
    { name: "ngramSearchCaseInsensitiveUTF8", description: "" },
    { name: "ngramSearchUTF8", description: "" },
    { name: "ngramSimHash", description: "" },
    { name: "ngramSimHashCaseInsensitive", description: "" },
    { name: "ngramSimHashCaseInsensitiveUTF8", description: "" },
    { name: "ngramSimHashUTF8", description: "" },
    { name: "nonNegativeDerivative", description: "" },
    { name: "normalizedQueryHash", description: "" },
    { name: "normalizedQueryHashKeepNames", description: "" },
    { name: "normalizeL1", description: "" },
    { name: "normalizeL2", description: "" },
    { name: "normalizeLinf", description: "" },
    { name: "normalizeLp", description: "" },
    { name: "normalizeQuery", description: "" },
    { name: "normalizeQueryKeepNames", description: "" },
    { name: "normalizeUTF8NFC", description: "" },
    { name: "normalizeUTF8NFD", description: "" },
    { name: "normalizeUTF8NFKC", description: "" },
    { name: "normalizeUTF8NFKD", description: "" },
    { name: "normL1", description: "" },
    { name: "normL2", description: "" },
    { name: "normL2Squared", description: "" },
    { name: "normLinf", description: "" },
    { name: "normLp", description: "" },
    { name: "not", description: "" },
    { name: "notEmpty", description: "" },
    { name: "notEquals", description: "" },
    { name: "nothing", description: "" },
    { name: "nothingNull", description: "" },
    { name: "nothingUInt64", description: "" },
    { name: "notILike", description: "" },
    { name: "notIn", description: "" },
    { name: "notInIgnoreSet", description: "" },
    { name: "notLike", description: "" },
    { name: "notNullIn", description: "" },
    { name: "notNullInIgnoreSet", description: "" },
    { name: "now", description: "" },
    { name: "now64", description: "" },
    { name: "nowInBlock", description: "" },
    { name: "nth_value", description: "" },
    { name: "ntile", description: "" },
    { name: "nullIf", description: "" },
    { name: "nullIn", description: "" },
    { name: "nullInIgnoreSet", description: "" },
    { name: "OCTET_LENGTH", description: "" },
    { name: "or", description: "" },
    { name: "overlay", description: "" },
    { name: "overlayUTF8", description: "" },
    { name: "parseDateTime", description: "" },
    { name: "parseDateTime32BestEffort", description: "" },
    { name: "parseDateTime32BestEffortOrNull", description: "" },
    { name: "parseDateTime32BestEffortOrZero", description: "" },
    { name: "parseDateTime64", description: "" },
    { name: "parseDateTime64BestEffort", description: "" },
    { name: "parseDateTime64BestEffortOrNull", description: "" },
    { name: "parseDateTime64BestEffortOrZero", description: "" },
    { name: "parseDateTime64BestEffortUS", description: "" },
    { name: "parseDateTime64BestEffortUSOrNull", description: "" },
    { name: "parseDateTime64BestEffortUSOrZero", description: "" },
    { name: "parseDateTime64InJodaSyntax", description: "" },
    { name: "parseDateTime64InJodaSyntaxOrNull", description: "" },
    { name: "parseDateTime64InJodaSyntaxOrZero", description: "" },
    { name: "parseDateTime64OrNull", description: "" },
    { name: "parseDateTime64OrZero", description: "" },
    { name: "parseDateTimeBestEffort", description: "" },
    { name: "parseDateTimeBestEffortOrNull", description: "" },
    { name: "parseDateTimeBestEffortOrZero", description: "" },
    { name: "parseDateTimeBestEffortUS", description: "" },
    { name: "parseDateTimeBestEffortUSOrNull", description: "" },
    { name: "parseDateTimeBestEffortUSOrZero", description: "" },
    { name: "parseDateTimeInJodaSyntax", description: "" },
    { name: "parseDateTimeInJodaSyntaxOrNull", description: "" },
    { name: "parseDateTimeInJodaSyntaxOrZero", description: "" },
    { name: "parseDateTimeOrNull", description: "" },
    { name: "parseDateTimeOrZero", description: "" },
    { name: "parseReadableSize", description: "" },
    { name: "parseReadableSizeOrNull", description: "" },
    { name: "parseReadableSizeOrZero", description: "" },
    { name: "parseTimeDelta", description: "" },
    { name: "partitionID", description: "" },
    { name: "path", description: "" },
    { name: "pathFull", description: "" },
    { name: "percent_rank", description: "" },
    { name: "percentRank", description: "" },
    { name: "pi", description: "" },
    { name: "plus", description: "" },
    { name: "pmod", description: "" },
    { name: "pointInEllipses", description: "" },
    { name: "pointInPolygon", description: "" },
    { name: "polygonAreaCartesian", description: "" },
    { name: "polygonAreaSpherical", description: "" },
    { name: "polygonConvexHullCartesian", description: "" },
    { name: "polygonPerimeterCartesian", description: "" },
    { name: "polygonPerimeterSpherical", description: "" },
    { name: "polygonsDistanceCartesian", description: "" },
    { name: "polygonsDistanceSpherical", description: "" },
    { name: "polygonsEqualsCartesian", description: "" },
    { name: "polygonsIntersectionCartesian", description: "" },
    { name: "polygonsIntersectionSpherical", description: "" },
    { name: "polygonsSymDifferenceCartesian", description: "" },
    { name: "polygonsSymDifferenceSpherical", description: "" },
    { name: "polygonsUnionCartesian", description: "" },
    { name: "polygonsUnionSpherical", description: "" },
    { name: "polygonsWithinCartesian", description: "" },
    { name: "polygonsWithinSpherical", description: "" },
    { name: "port", description: "" },
    { name: "portRFC", description: "" },
    { name: "position", description: "" },
    { name: "positionCaseInsensitive", description: "" },
    { name: "positionCaseInsensitiveUTF8", description: "" },
    { name: "positionUTF8", description: "" },
    { name: "positive_modulo", description: "" },
    { name: "positiveModulo", description: "" },
    { name: "pow", description: "" },
    { name: "power", description: "" },
    { name: "printf", description: "" },
    { name: "proportionsZTest", description: "" },
    { name: "protocol", description: "" },
    { name: "punycodeDecode", description: "" },
    { name: "punycodeEncode", description: "" },
    { name: "quantile", description: "" },
    { name: "quantileBFloat16", description: "" },
    { name: "quantileBFloat16Weighted", description: "" },
    { name: "quantileDD", description: "" },
    { name: "quantileDeterministic", description: "" },
    { name: "quantileExact", description: "" },
    { name: "quantileExactExclusive", description: "" },
    { name: "quantileExactHigh", description: "" },
    { name: "quantileExactInclusive", description: "" },
    { name: "quantileExactLow", description: "" },
    { name: "quantileExactWeighted", description: "" },
    { name: "quantileExactWeightedInterpolated", description: "" },
    { name: "quantileGK", description: "" },
    { name: "quantileInterpolatedWeighted", description: "" },
    { name: "quantiles", description: "" },
    { name: "quantilesBFloat16", description: "" },
    { name: "quantilesBFloat16Weighted", description: "" },
    { name: "quantilesDD", description: "" },
    { name: "quantilesDeterministic", description: "" },
    { name: "quantilesExact", description: "" },
    { name: "quantilesExactExclusive", description: "" },
    { name: "quantilesExactHigh", description: "" },
    { name: "quantilesExactInclusive", description: "" },
    { name: "quantilesExactLow", description: "" },
    { name: "quantilesExactWeighted", description: "" },
    { name: "quantilesExactWeightedInterpolated", description: "" },
    { name: "quantilesGK", description: "" },
    { name: "quantilesInterpolatedWeighted", description: "" },
    { name: "quantilesTDigest", description: "" },
    { name: "quantilesTDigestWeighted", description: "" },
    { name: "quantilesTiming", description: "" },
    { name: "quantilesTimingWeighted", description: "" },
    { name: "quantileTDigest", description: "" },
    { name: "quantileTDigestWeighted", description: "" },
    { name: "quantileTiming", description: "" },
    { name: "quantileTimingWeighted", description: "" },
    { name: "QUARTER", description: "" },
    { name: "query_id", description: "" },
    { name: "queryID", description: "" },
    { name: "queryString", description: "" },
    { name: "queryStringAndFragment", description: "" },
    { name: "radians", description: "" },
    { name: "rand", description: "" },
    { name: "rand32", description: "" },
    { name: "rand64", description: "" },
    { name: "randBernoulli", description: "" },
    { name: "randBinomial", description: "" },
    { name: "randCanonical", description: "" },
    { name: "randChiSquared", description: "" },
    { name: "randConstant", description: "" },
    { name: "randExponential", description: "" },
    { name: "randFisherF", description: "" },
    { name: "randLogNormal", description: "" },
    { name: "randNegativeBinomial", description: "" },
    { name: "randNormal", description: "" },
    { name: "randomFixedString", description: "" },
    { name: "randomPrintableASCII", description: "" },
    { name: "randomString", description: "" },
    { name: "randomStringUTF8", description: "" },
    { name: "randPoisson", description: "" },
    { name: "randStudentT", description: "" },
    { name: "randUniform", description: "" },
    { name: "range", description: "" },
    { name: "rank", description: "" },
    { name: "rankCorr", description: "" },
    { name: "readWKTLineString", description: "" },
    { name: "readWKTMultiLineString", description: "" },
    { name: "readWKTMultiPolygon", description: "" },
    { name: "readWKTPoint", description: "" },
    { name: "readWKTPolygon", description: "" },
    { name: "readWKTRing", description: "" },
    { name: "REGEXP_EXTRACT", description: "" },
    { name: "REGEXP_MATCHES", description: "" },
    { name: "REGEXP_REPLACE", description: "" },
    { name: "regexpExtract", description: "" },
    { name: "regexpQuoteMeta", description: "" },
    { name: "regionHierarchy", description: "" },
    { name: "regionIn", description: "" },
    { name: "regionToArea", description: "" },
    { name: "regionToCity", description: "" },
    { name: "regionToContinent", description: "" },
    { name: "regionToCountry", description: "" },
    { name: "regionToDistrict", description: "" },
    { name: "regionToName", description: "" },
    { name: "regionToPopulation", description: "" },
    { name: "regionToTopContinent", description: "" },
    { name: "reinterpret", description: "" },
    { name: "reinterpretAsDate", description: "" },
    { name: "reinterpretAsDateTime", description: "" },
    { name: "reinterpretAsFixedString", description: "" },
    { name: "reinterpretAsFloat32", description: "" },
    { name: "reinterpretAsFloat64", description: "" },
    { name: "reinterpretAsInt128", description: "" },
    { name: "reinterpretAsInt16", description: "" },
    { name: "reinterpretAsInt256", description: "" },
    { name: "reinterpretAsInt32", description: "" },
    { name: "reinterpretAsInt64", description: "" },
    { name: "reinterpretAsInt8", description: "" },
    { name: "reinterpretAsString", description: "" },
    { name: "reinterpretAsUInt128", description: "" },
    { name: "reinterpretAsUInt16", description: "" },
    { name: "reinterpretAsUInt256", description: "" },
    { name: "reinterpretAsUInt32", description: "" },
    { name: "reinterpretAsUInt64", description: "" },
    { name: "reinterpretAsUInt8", description: "" },
    { name: "reinterpretAsUUID", description: "" },
    { name: "repeat", description: "" },
    { name: "replace", description: "" },
    { name: "replaceAll", description: "" },
    { name: "replaceOne", description: "" },
    { name: "replaceRegexpAll", description: "" },
    { name: "replaceRegexpOne", description: "" },
    { name: "replicate", description: "" },
    { name: "retention", description: "" },
    { name: "reverse", description: "" },
    { name: "reverseUTF8", description: "" },
    { name: "revision", description: "" },
    { name: "right", description: "" },
    { name: "rightPad", description: "" },
    { name: "rightPadUTF8", description: "" },
    { name: "rightUTF8", description: "" },
    { name: "RIPEMD160", description: "" },
    { name: "round", description: "" },
    { name: "roundAge", description: "" },
    { name: "roundBankers", description: "" },
    { name: "roundDown", description: "" },
    { name: "roundDuration", description: "" },
    { name: "roundToExp2", description: "" },
    { name: "row_number", description: "" },
    { name: "rowNumberInAllBlocks", description: "" },
    { name: "rowNumberInBlock", description: "" },
    { name: "rpad", description: "" },
    { name: "rtrim", description: "" },
    { name: "runningAccumulate", description: "" },
    { name: "runningConcurrency", description: "" },
    { name: "runningDifference", description: "" },
    { name: "runningDifferenceStartingWithFirstValue", description: "" },
    { name: "s2CapContains", description: "" },
    { name: "s2CapUnion", description: "" },
    { name: "s2CellsIntersect", description: "" },
    { name: "s2GetNeighbors", description: "" },
    { name: "s2RectAdd", description: "" },
    { name: "s2RectContains", description: "" },
    { name: "s2RectIntersection", description: "" },
    { name: "s2RectUnion", description: "" },
    { name: "s2ToGeo", description: "" },
    { name: "scalarProduct", description: "" },
    { name: "SCHEMA", description: "" },
    { name: "SECOND", description: "" },
    { name: "sequenceCount", description: "" },
    { name: "sequenceMatch", description: "" },
    { name: "sequenceMatchEvents", description: "" },
    { name: "sequenceNextNode", description: "" },
    { name: "seriesDecomposeSTL", description: "" },
    { name: "seriesOutliersDetectTukey", description: "" },
    { name: "seriesPeriodDetectFFT", description: "" },
    { name: "serverTimeZone", description: "" },
    { name: "serverUUID", description: "" },
    { name: "SHA1", description: "" },
    { name: "SHA224", description: "" },
    { name: "SHA256", description: "" },
    { name: "SHA384", description: "" },
    { name: "SHA512", description: "" },
    { name: "SHA512_256", description: "" },
    { name: "shardCount", description: "" },
    { name: "shardNum", description: "" },
    { name: "showCertificate", description: "" },
    { name: "sigmoid", description: "" },
    { name: "sign", description: "" },
    { name: "simpleJSONExtractBool", description: "" },
    { name: "simpleJSONExtractFloat", description: "" },
    { name: "simpleJSONExtractInt", description: "" },
    { name: "simpleJSONExtractRaw", description: "" },
    { name: "simpleJSONExtractString", description: "" },
    { name: "simpleJSONExtractUInt", description: "" },
    { name: "simpleJSONHas", description: "" },
    { name: "simpleLinearRegression", description: "" },
    { name: "sin", description: "" },
    { name: "singleValueOrNull", description: "" },
    { name: "sinh", description: "" },
    { name: "sipHash128", description: "" },
    { name: "sipHash128Keyed", description: "" },
    { name: "sipHash128Reference", description: "" },
    { name: "sipHash128ReferenceKeyed", description: "" },
    { name: "sipHash64", description: "" },
    { name: "sipHash64Keyed", description: "" },
    { name: "skewPop", description: "" },
    { name: "skewSamp", description: "" },
    { name: "sleep", description: "" },
    { name: "sleepEachRow", description: "" },
    { name: "snowflakeIDToDateTime", description: "" },
    { name: "snowflakeIDToDateTime64", description: "" },
    { name: "snowflakeToDateTime", description: "" },
    { name: "snowflakeToDateTime64", description: "" },
    { name: "soundex", description: "" },
    { name: "space", description: "" },
    { name: "sparkBar", description: "" },
    { name: "splitByAlpha", description: "" },
    { name: "splitByChar", description: "" },
    { name: "splitByNonAlpha", description: "" },
    { name: "splitByRegexp", description: "" },
    { name: "splitByString", description: "" },
    { name: "splitByWhitespace", description: "" },
    { name: "sqid", description: "" },
    { name: "sqidDecode", description: "" },
    { name: "sqidEncode", description: "" },
    { name: "sqrt", description: "" },
    { name: "startsWith", description: "" },
    { name: "startsWithUTF8", description: "" },
    { name: "STD", description: "" },
    { name: "STDDEV_POP", description: "" },
    { name: "STDDEV_SAMP", description: "" },
    { name: "stddevPop", description: "" },
    { name: "stddevPopStable", description: "" },
    { name: "stddevSamp", description: "" },
    { name: "stddevSampStable", description: "" },
    { name: "stem", description: "" },
    { name: "stochasticLinearRegression", description: "" },
    { name: "stochasticLogisticRegression", description: "" },
    { name: "str_to_date", description: "" },
    { name: "str_to_map", description: "" },
    { name: "stringJaccardIndex", description: "" },
    { name: "stringJaccardIndexUTF8", description: "" },
    { name: "stringToH3", description: "" },
    { name: "structureToCapnProtoSchema", description: "" },
    { name: "structureToProtobufSchema", description: "" },
    { name: "studentTTest", description: "" },
    { name: "subBitmap", description: "" },
    { name: "subDate", description: "" },
    { name: "substr", description: "" },
    { name: "substring", description: "" },
    { name: "SUBSTRING_INDEX", description: "" },
    { name: "substringIndex", description: "" },
    { name: "substringIndexUTF8", description: "" },
    { name: "substringUTF8", description: "" },
    { name: "subtractDays", description: "" },
    { name: "subtractHours", description: "" },
    { name: "subtractInterval", description: "" },
    { name: "subtractMicroseconds", description: "" },
    { name: "subtractMilliseconds", description: "" },
    { name: "subtractMinutes", description: "" },
    { name: "subtractMonths", description: "" },
    { name: "subtractNanoseconds", description: "" },
    { name: "subtractQuarters", description: "" },
    { name: "subtractSeconds", description: "" },
    { name: "subtractTupleOfIntervals", description: "" },
    { name: "subtractWeeks", description: "" },
    { name: "subtractYears", description: "" },
    { name: "sum", description: "" },
    { name: "sumCount", description: "" },
    { name: "sumKahan", description: "" },
    { name: "sumMapFiltered", description: "" },
    { name: "sumMapFilteredWithOverflow", description: "" },
    { name: "sumMappedArrays", description: "" },
    { name: "sumMapWithOverflow", description: "" },
    { name: "sumWithOverflow", description: "" },
    { name: "SVG", description: "" },
    { name: "synonyms", description: "" },
    { name: "tan", description: "" },
    { name: "tanh", description: "" },
    { name: "tcpPort", description: "" },
    { name: "tgamma", description: "" },
    { name: "theilsU", description: "" },
    { name: "throwIf", description: "" },
    { name: "tid", description: "" },
    { name: "time_bucket", description: "" },
    { name: "timeDiff", description: "" },
    { name: "timeSlot", description: "" },
    { name: "timeSlots", description: "" },
    { name: "timestamp", description: "" },
    { name: "TIMESTAMP_DIFF", description: "" },
    { name: "timestampDiff", description: "" },
    { name: "timeZone", description: "" },
    { name: "timeZoneOf", description: "" },
    { name: "timeZoneOffset", description: "" },
    { name: "TO_BASE64", description: "" },
    { name: "TO_DAYS", description: "" },
    { name: "TO_UNIXTIME", description: "" },
    { name: "to_utc_timestamp", description: "" },
    { name: "toBFloat16", description: "" },
    { name: "toBFloat16OrNull", description: "" },
    { name: "toBFloat16OrZero", description: "" },
    { name: "toBool", description: "" },
    { name: "toColumnTypeName", description: "" },
    { name: "toDate", description: "" },
    { name: "toDate32", description: "" },
    { name: "toDate32OrDefault", description: "" },
    { name: "toDate32OrNull", description: "" },
    { name: "toDate32OrZero", description: "" },
    { name: "toDateOrDefault", description: "" },
    { name: "toDateOrNull", description: "" },
    { name: "toDateOrZero", description: "" },
    { name: "toDateTime", description: "" },
    { name: "toDateTime32", description: "" },
    { name: "toDateTime64", description: "" },
    { name: "toDateTime64OrDefault", description: "" },
    { name: "toDateTime64OrNull", description: "" },
    { name: "toDateTime64OrZero", description: "" },
    { name: "toDateTimeOrDefault", description: "" },
    { name: "toDateTimeOrNull", description: "" },
    { name: "toDateTimeOrZero", description: "" },
    { name: "today", description: "" },
    { name: "toDayOfMonth", description: "" },
    { name: "toDayOfWeek", description: "" },
    { name: "toDayOfYear", description: "" },
    { name: "toDaysSinceYearZero", description: "" },
    { name: "toDecimal128", description: "" },
    { name: "toDecimal128OrDefault", description: "" },
    { name: "toDecimal128OrNull", description: "" },
    { name: "toDecimal128OrZero", description: "" },
    { name: "toDecimal256", description: "" },
    { name: "toDecimal256OrDefault", description: "" },
    { name: "toDecimal256OrNull", description: "" },
    { name: "toDecimal256OrZero", description: "" },
    { name: "toDecimal32", description: "" },
    { name: "toDecimal32OrDefault", description: "" },
    { name: "toDecimal32OrNull", description: "" },
    { name: "toDecimal32OrZero", description: "" },
    { name: "toDecimal64", description: "" },
    { name: "toDecimal64OrDefault", description: "" },
    { name: "toDecimal64OrNull", description: "" },
    { name: "toDecimal64OrZero", description: "" },
    { name: "toDecimalString", description: "" },
    { name: "toFixedString", description: "" },
    { name: "toFloat32", description: "" },
    { name: "toFloat32OrDefault", description: "" },
    { name: "toFloat32OrNull", description: "" },
    { name: "toFloat32OrZero", description: "" },
    { name: "toFloat64", description: "" },
    { name: "toFloat64OrDefault", description: "" },
    { name: "toFloat64OrNull", description: "" },
    { name: "toFloat64OrZero", description: "" },
    { name: "toHour", description: "" },
    { name: "toInt128", description: "" },
    { name: "toInt128OrDefault", description: "" },
    { name: "toInt128OrNull", description: "" },
    { name: "toInt128OrZero", description: "" },
    { name: "toInt16", description: "" },
    { name: "toInt16OrDefault", description: "" },
    { name: "toInt16OrNull", description: "" },
    { name: "toInt16OrZero", description: "" },
    { name: "toInt256", description: "" },
    { name: "toInt256OrDefault", description: "" },
    { name: "toInt256OrNull", description: "" },
    { name: "toInt256OrZero", description: "" },
    { name: "toInt32", description: "" },
    { name: "toInt32OrDefault", description: "" },
    { name: "toInt32OrNull", description: "" },
    { name: "toInt32OrZero", description: "" },
    { name: "toInt64", description: "" },
    { name: "toInt64OrDefault", description: "" },
    { name: "toInt64OrNull", description: "" },
    { name: "toInt64OrZero", description: "" },
    { name: "toInt8", description: "" },
    { name: "toInt8OrDefault", description: "" },
    { name: "toInt8OrNull", description: "" },
    { name: "toInt8OrZero", description: "" },
    { name: "toIntervalDay", description: "" },
    { name: "toIntervalHour", description: "" },
    { name: "toIntervalMicrosecond", description: "" },
    { name: "toIntervalMillisecond", description: "" },
    { name: "toIntervalMinute", description: "" },
    { name: "toIntervalMonth", description: "" },
    { name: "toIntervalNanosecond", description: "" },
    { name: "toIntervalQuarter", description: "" },
    { name: "toIntervalSecond", description: "" },
    { name: "toIntervalWeek", description: "" },
    { name: "toIntervalYear", description: "" },
    { name: "toIPv4", description: "" },
    { name: "toIPv4OrDefault", description: "" },
    { name: "toIPv4OrNull", description: "" },
    { name: "toIPv4OrZero", description: "" },
    { name: "toIPv6", description: "" },
    { name: "toIPv6OrDefault", description: "" },
    { name: "toIPv6OrNull", description: "" },
    { name: "toIPv6OrZero", description: "" },
    { name: "toISOWeek", description: "" },
    { name: "toISOYear", description: "" },
    { name: "toJSONString", description: "" },
    { name: "tokens", description: "" },
    { name: "toLastDayOfMonth", description: "" },
    { name: "toLastDayOfWeek", description: "" },
    { name: "toLowCardinality", description: "" },
    { name: "toMillisecond", description: "" },
    { name: "toMinute", description: "" },
    { name: "toModifiedJulianDay", description: "" },
    { name: "toModifiedJulianDayOrNull", description: "" },
    { name: "toMonday", description: "" },
    { name: "toMonth", description: "" },
    { name: "toMonthNumSinceEpoch", description: "" },
    { name: "toNullable", description: "" },
    { name: "topK", description: "" },
    { name: "topKWeighted", description: "" },
    { name: "topLevelDomain", description: "" },
    { name: "topLevelDomainRFC", description: "" },
    { name: "toQuarter", description: "" },
    { name: "toRelativeDayNum", description: "" },
    { name: "toRelativeHourNum", description: "" },
    { name: "toRelativeMinuteNum", description: "" },
    { name: "toRelativeMonthNum", description: "" },
    { name: "toRelativeQuarterNum", description: "" },
    { name: "toRelativeSecondNum", description: "" },
    { name: "toRelativeWeekNum", description: "" },
    { name: "toRelativeYearNum", description: "" },
    { name: "toSecond", description: "" },
    { name: "toStartOfDay", description: "" },
    { name: "toStartOfFifteenMinutes", description: "" },
    { name: "toStartOfFiveMinute", description: "" },
    { name: "toStartOfFiveMinutes", description: "" },
    { name: "toStartOfHour", description: "" },
    { name: "toStartOfInterval", description: "" },
    { name: "toStartOfISOYear", description: "" },
    { name: "toStartOfMicrosecond", description: "" },
    { name: "toStartOfMillisecond", description: "" },
    { name: "toStartOfMinute", description: "" },
    { name: "toStartOfMonth", description: "" },
    { name: "toStartOfNanosecond", description: "" },
    { name: "toStartOfQuarter", description: "" },
    { name: "toStartOfSecond", description: "" },
    { name: "toStartOfTenMinutes", description: "" },
    { name: "toStartOfWeek", description: "" },
    { name: "toStartOfYear", description: "" },
    { name: "toString", description: "" },
    { name: "toStringCutToZero", description: "" },
    { name: "toTime", description: "" },
    { name: "toTimeZone", description: "" },
    { name: "toTypeName", description: "" },
    { name: "toUInt128", description: "" },
    { name: "toUInt128OrDefault", description: "" },
    { name: "toUInt128OrNull", description: "" },
    { name: "toUInt128OrZero", description: "" },
    { name: "toUInt16", description: "" },
    { name: "toUInt16OrDefault", description: "" },
    { name: "toUInt16OrNull", description: "" },
    { name: "toUInt16OrZero", description: "" },
    { name: "toUInt256", description: "" },
    { name: "toUInt256OrDefault", description: "" },
    { name: "toUInt256OrNull", description: "" },
    { name: "toUInt256OrZero", description: "" },
    { name: "toUInt32", description: "" },
    { name: "toUInt32OrDefault", description: "" },
    { name: "toUInt32OrNull", description: "" },
    { name: "toUInt32OrZero", description: "" },
    { name: "toUInt64", description: "" },
    { name: "toUInt64OrDefault", description: "" },
    { name: "toUInt64OrNull", description: "" },
    { name: "toUInt64OrZero", description: "" },
    { name: "toUInt8", description: "" },
    { name: "toUInt8OrDefault", description: "" },
    { name: "toUInt8OrNull", description: "" },
    { name: "toUInt8OrZero", description: "" },
    { name: "toUnixTimestamp", description: "" },
    { name: "toUnixTimestamp64Micro", description: "" },
    { name: "toUnixTimestamp64Milli", description: "" },
    { name: "toUnixTimestamp64Nano", description: "" },
    { name: "toUnixTimestamp64Second", description: "" },
    { name: "toUTCTimestamp", description: "" },
    { name: "toUUID", description: "" },
    { name: "toUUIDOrDefault", description: "" },
    { name: "toUUIDOrNull", description: "" },
    { name: "toUUIDOrZero", description: "" },
    { name: "toValidUTF8", description: "" },
    { name: "toWeek", description: "" },
    { name: "toYear", description: "" },
    { name: "toYearNumSinceEpoch", description: "" },
    { name: "toYearWeek", description: "" },
    { name: "toYYYYMM", description: "" },
    { name: "toYYYYMMDD", description: "" },
    { name: "toYYYYMMDDhhmmss", description: "" },
    { name: "transactionID", description: "" },
    { name: "transactionLatestSnapshot", description: "" },
    { name: "transactionOldestSnapshot", description: "" },
    { name: "transform", description: "" },
    { name: "translate", description: "" },
    { name: "translateUTF8", description: "" },
    { name: "trim", description: "" },
    { name: "trimBoth", description: "" },
    { name: "trimLeft", description: "" },
    { name: "trimRight", description: "" },
    { name: "trunc", description: "" },
    { name: "truncate", description: "" },
    { name: "tryBase58Decode", description: "" },
    { name: "tryBase64Decode", description: "" },
    { name: "tryBase64URLDecode", description: "" },
    { name: "tryDecrypt", description: "" },
    { name: "tryIdnaEncode", description: "" },
    { name: "tryPunycodeDecode", description: "" },
    { name: "tumble", description: "" },
    { name: "tumbleEnd", description: "" },
    { name: "tumbleStart", description: "" },
    { name: "tuple", description: "" },
    { name: "tupleConcat", description: "" },
    { name: "tupleDivide", description: "" },
    { name: "tupleDivideByNumber", description: "" },
    { name: "tupleElement", description: "" },
    { name: "tupleHammingDistance", description: "" },
    { name: "tupleIntDiv", description: "" },
    { name: "tupleIntDivByNumber", description: "" },
    { name: "tupleIntDivOrZero", description: "" },
    { name: "tupleIntDivOrZeroByNumber", description: "" },
    { name: "tupleMinus", description: "" },
    { name: "tupleModulo", description: "" },
    { name: "tupleModuloByNumber", description: "" },
    { name: "tupleMultiply", description: "" },
    { name: "tupleMultiplyByNumber", description: "" },
    { name: "tupleNames", description: "" },
    { name: "tupleNegate", description: "" },
    { name: "tuplePlus", description: "" },
    { name: "tupleToNameValuePairs", description: "" },
    { name: "ucase", description: "" },
    { name: "ULIDStringToDateTime", description: "" },
    { name: "unbin", description: "" },
    { name: "unhex", description: "" },
    { name: "uniq", description: "" },
    { name: "uniqCombined", description: "" },
    { name: "uniqCombined64", description: "" },
    { name: "uniqExact", description: "" },
    { name: "uniqHLL12", description: "" },
    { name: "uniqTheta", description: "" },
    { name: "uniqThetaIntersect", description: "" },
    { name: "uniqThetaNot", description: "" },
    { name: "uniqThetaUnion", description: "" },
    { name: "uniqUpTo", description: "" },
    { name: "upper", description: "" },
    { name: "upperUTF8", description: "" },
    { name: "uptime", description: "" },
    { name: "URLHash", description: "" },
    { name: "URLHierarchy", description: "" },
    { name: "URLPathHierarchy", description: "" },
    { name: "user", description: "" },
    { name: "UTC_timestamp", description: "" },
    { name: "UTCTimestamp", description: "" },
    { name: "UUIDNumToString", description: "" },
    { name: "UUIDStringToNum", description: "" },
    { name: "UUIDToNum", description: "" },
    { name: "UUIDv7ToDateTime", description: "" },
    { name: "validateNestedArraySizes", description: "" },
    { name: "VAR_POP", description: "" },
    { name: "VAR_SAMP", description: "" },
    { name: "variantElement", description: "" },
    { name: "variantType", description: "" },
    { name: "varPop", description: "" },
    { name: "varPopStable", description: "" },
    { name: "varSamp", description: "" },
    { name: "varSampStable", description: "" },
    { name: "vectorDifference", description: "" },
    { name: "vectorSum", description: "" },
    { name: "version", description: "" },
    { name: "visibleWidth", description: "" },
    { name: "visitParamExtractBool", description: "" },
    { name: "visitParamExtractFloat", description: "" },
    { name: "visitParamExtractInt", description: "" },
    { name: "visitParamExtractRaw", description: "" },
    { name: "visitParamExtractString", description: "" },
    { name: "visitParamExtractUInt", description: "" },
    { name: "visitParamHas", description: "" },
    { name: "week", description: "" },
    { name: "welchTTest", description: "" },
    { name: "width_bucket", description: "" },
    { name: "widthBucket", description: "" },
    { name: "windowFunnel", description: "" },
    { name: "windowID", description: "" },
    { name: "wkt", description: "" },
    { name: "wordShingleMinHash", description: "" },
    { name: "wordShingleMinHashArg", description: "" },
    { name: "wordShingleMinHashArgCaseInsensitive", description: "" },
    { name: "wordShingleMinHashArgCaseInsensitiveUTF8", description: "" },
    { name: "wordShingleMinHashArgUTF8", description: "" },
    { name: "wordShingleMinHashCaseInsensitive", description: "" },
    { name: "wordShingleMinHashCaseInsensitiveUTF8", description: "" },
    { name: "wordShingleMinHashUTF8", description: "" },
    { name: "wordShingleSimHash", description: "" },
    { name: "wordShingleSimHashCaseInsensitive", description: "" },
    { name: "wordShingleSimHashCaseInsensitiveUTF8", description: "" },
    { name: "wordShingleSimHashUTF8", description: "" },
    { name: "wyHash64", description: "" },
    { name: "xor", description: "" },
    { name: "xxh3", description: "" },
    { name: "xxHash32", description: "" },
    { name: "xxHash64", description: "" },
    { name: "yandexConsistentHash", description: "" },
    { name: "YEAR", description: "" },
    { name: "yearweek", description: "" },
    { name: "yesterday", description: "" },
    { name: "YYYYMMDDhhmmssToDateTime", description: "" },
    { name: "YYYYMMDDhhmmssToDateTime64", description: "" },
    { name: "YYYYMMDDToDate", description: "" },
    { name: "YYYYMMDDToDate32", description: "" },
    { name: "zookeeperSessionUptime", description: "" }
];
